import { jsxs as M, jsx as m } from "react/jsx-runtime";
import r from "clsx";
import { forwardRef as V, useState as D, useEffect as L, useMemo as x } from "react";
import w from "react-select";
import E from "react-select/async";
import F from "react-select/async-creatable";
import y from "react-select/creatable";
import { ClearIndicator as O } from "./ClearIndicator.js";
import { DropdownIndicator as H } from "./DropdownIndicator.js";
import { MultiValue as I } from "./MultiValue.js";
import { MultiValueLabel as N } from "./MultiValueLabel.js";
import { MultiValueRemove as R } from "./MultiValueRemove.js";
import { Option as A } from "./Option.js";
import e from "./Select.module.css.js";
import { useInputErrorMessages as j } from "../InputErrorMessage/useInputErrorMessages.js";
import { InputErrorMessage as k } from "../InputErrorMessage/InputErrorMessage.js";
const P = ({
  async: c,
  creatable: a,
  error: d,
  isDisabled: n,
  components: p,
  className: f,
  onChange: v,
  ...s
}, S) => {
  const { isInvalid: i, errorMessages: l } = j(d), [t, g] = D(null);
  L(() => {
    if (!t)
      return;
    const o = (b) => {
      ["Tab", "ArrowUp", "ArrowDown"].includes(b.code) && t.classList.add(e.louisSelectFocusOutlineShouldBeVisible);
    }, u = () => {
      t.classList.remove(e.louisSelectFocusOutlineShouldBeVisible);
    };
    return t.addEventListener("mouseover", u), t.addEventListener("keydown", o), () => {
      t.removeEventListener("mouseover", u), t.removeEventListener("keydown", o);
    };
  }, [t]);
  const C = c ? a ? F : E : a ? y : w, h = x(
    () => ({
      container: () => e.container,
      control: (o) => o.isDisabled ? r(e.control, e.controlDisabled) : o.isFocused ? r(e.control, e.controlFocused) : i ? r(e.control, e.controlError) : e.control,
      indicatorsContainer: () => e.indicatorsContainer,
      indicatorSeparator: () => e.indicatorSeparator,
      input: () => e.input,
      menu: () => e.menu,
      menuList: () => e.menuList,
      menuPortal: () => e.menuPortal,
      multiValue: () => e.multiValue,
      multiValueLabel: (o) => o.isDisabled ? e.multiValueLabelDisabled : "",
      multiValueRemove: () => e.multiValueRemove,
      noOptionsMessage: () => e.noOptionsMessage,
      option: (o) => o.isDisabled ? r(e.option, e.optionDisabled) : o.isSelected ? r(e.option, e.optionSelected, {
        [e.optionFocused]: o.isFocused
      }) : o.isFocused ? r(e.option, e.optionFocused) : e.option,
      placeholder: (o) => o.isDisabled ? r(e.placeholder, e.placeholderDisabled) : e.placeholder,
      singleValue: (o) => o.isDisabled ? r(e.singleValue, e.singleValueDisabled) : e.singleValue,
      valueContainer: (o) => o.isMulti ? r(e.valueContainer, e.valueContainerMulti) : n ? r(e.valueContainer, e.valueContainerDisabled) : e.valueContainer
    }),
    [n, i]
  );
  return /* @__PURE__ */ M(
    "div",
    {
      className: r(e.parentContainer, {
        [e.parentContainerDisabled]: n
      }),
      ref: g,
      style: {
        "--louis-select-max-menu-height": s.maxMenuHeight ? `${s.maxMenuHeight}px` : "282px"
      },
      children: [
        /* @__PURE__ */ m(
          C,
          {
            className: r(e.select, f),
            disabled: n,
            isDisabled: n,
            ref: S,
            classNamePrefix: "Select",
            classNames: h,
            error: i,
            "aria-invalid": i,
            "aria-errormessage": l.length > 0 ? l.map((o) => o.id).join(" ") : void 0,
            components: {
              MultiValueLabel: N,
              MultiValueRemove: R,
              MultiValue: I,
              ClearIndicator: O,
              DropdownIndicator: H,
              Option: A,
              ...p
            },
            noOptionsMessage: () => "No matches found",
            ...a ? { formatCreateLabel: (o) => `+ Add "${o}"` } : {},
            onChange: v,
            minMenuHeight: 282,
            maxMenuHeight: 282,
            ...s
          }
        ),
        l.length > 0 && /* @__PURE__ */ m(k, { children: l })
      ]
    }
  );
}, oe = V(P);
export {
  oe as Select
};
//# sourceMappingURL=Select.js.map
